import { useEffect } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from './stores/authStore'
import { AppLayout } from './components/layout/AppLayout'
import { LoginScreen } from './components/auth/LoginScreen'
import { SplashScreen } from './components/common/SplashScreen'
import { DashboardPage } from './components/dashboard/DashboardPage'
import { AnalyzePage } from './components/analyze/AnalyzePage'
import { ReviewQueuePage } from './components/analyze/ReviewQueuePage'
import { SmartPayPage } from './components/smartpay/SmartPayPage'
import { MonitorPage } from './components/monitor/MonitorPage'
import { SettingsPage } from './components/settings/SettingsPage'
import { ActivitiesPage } from './components/activities/ActivitiesPage'
import { WhySelffiPage } from './components/why/WhySelffiPage'
import { RewardsPage } from './components/rewards/RewardsPage'
import { AdminPage } from './components/admin/AdminPage'

export default function App() {
  const token = useAuthStore((s) => s.token)
  const initialized = useAuthStore((s) => s.initialized)
  const user = useAuthStore((s) => s.user)
  const checkAuth = useAuthStore((s) => s.checkAuth)

  useEffect(() => {
    checkAuth()
  }, [checkAuth])

  // Show splash while checking auth
  if (!initialized) {
    return <SplashScreen />
  }

  if (!token) {
    return <LoginScreen />
  }

  return (
    <AppLayout>
      <Routes>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/analyze" element={<AnalyzePage />} />
        <Route path="/analyze/review" element={<ReviewQueuePage />} />
        <Route path="/smartpay" element={<SmartPayPage />} />
        <Route path="/monitor" element={<MonitorPage />} />
        <Route path="/activities" element={<ActivitiesPage />} />
        <Route path="/rewards" element={<RewardsPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/why-self-fi" element={<WhySelffiPage />} />
        {user?.is_admin && <Route path="/admin" element={<AdminPage />} />}
        {/* Legacy redirects */}
        <Route path="/transactions" element={<Navigate to="/activities" replace />} />
        <Route path="/why-selffi" element={<Navigate to="/why-self-fi" replace />} />
      </Routes>
    </AppLayout>
  )
}
